import React from "react";
import {
  Box,
  Button,
  TextField,
  FormControlLabel,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DownloadIcon from "@mui/icons-material/Download";
import { useTranslation } from "react-i18next";

const MODULE_PREFIX_OPTIONS = [
  { value: "", labelKey: "dsokCustomerDetail.translationsUI.root" },
  { value: "easyFood", labelKey: "dsokCustomerDetail.translationsUI.easyFood" },
  { value: "easyBuy", labelKey: "dsokCustomerDetail.translationsUI.easyBuy" },
];

const TranslationsTopBar = ({
  search,
  onSearchChange,
  missingOnly,
  onMissingOnlyChange,
  modulePrefix,
  onModulePrefixChange,
  showOnlyChanged,
  onShowOnlyChangedChange,
  onImportClick,
  onExportClick,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: 2,
        p: 1.5,
        borderBottom: 1,
        borderColor: "divider",
        bgcolor: "background.default",
      }}
    >
      {onImportClick && (
        <Button
          size="small"
          variant="outlined"
          startIcon={<UploadFileIcon />}
          onClick={onImportClick}
          aria-label={t("dsokCustomerDetail.translationsUI.import")}
        >
          {t("dsokCustomerDetail.translationsUI.import")}
        </Button>
      )}
      {onExportClick && (
        <Button
          size="small"
          variant="outlined"
          startIcon={<DownloadIcon />}
          onClick={onExportClick}
          aria-label={t("dsokCustomerDetail.translationsUI.export")}
        >
          {t("dsokCustomerDetail.translationsUI.export")}
        </Button>
      )}
      <TextField
        size="small"
        placeholder={t("dsokCustomerDetail.translationsUI.search")}
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
        }}
        sx={{ minWidth: 200 }}
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={!!missingOnly}
            onChange={(e) => onMissingOnlyChange(e.target.checked)}
          />
        }
        label={t("dsokCustomerDetail.translationsUI.missingTranslations")}
      />
      <FormControl size="small" sx={{ minWidth: 140 }}>
        <InputLabel>{t("dsokCustomerDetail.translationsUI.module")}</InputLabel>
        <Select
          value={modulePrefix}
          label={t("dsokCustomerDetail.translationsUI.module")}
          onChange={(e) => onModulePrefixChange(e.target.value)}
        >
          {MODULE_PREFIX_OPTIONS.map((opt) => (
            <MenuItem key={opt.value || "root"} value={opt.value}>
              {t(opt.labelKey)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControlLabel
        control={
          <Checkbox
            checked={!!showOnlyChanged}
            onChange={(e) => onShowOnlyChangedChange(e.target.checked)}
          />
        }
        label={t("dsokCustomerDetail.translationsUI.showOnlyChanged")}
      />
    </Box>
  );
};

export default TranslationsTopBar;
